var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('router-view'),(_vm.loading)?_c('Loading'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }